<template>
  <div class="home">
    <top-prompt></top-prompt>
    <carousel-view></carousel-view>
    <home-nav></home-nav>
<!--    <special-offer></special-offer>-->
    <!-- <holiday-inspiration></holiday-inspiration> -->
    <flying-us></flying-us>
  </div>
</template>

<script>
import CarouselView from "@/components/Carousel/Carousel";
import TopPrompt from "@/components/HomeComponents/TopPrompt";
import HomeNav from "@/components/HomeComponents/HomeNav/HomeNav";
import SpecialOffer from "@/components/HomeComponents/SpecialOffer";
// import HolidayInspiration from "@/components/HomeComponents/HolidayInspiration";
import FlyingUs from "@/components/HomeComponents/FlyingUs";

export default {
  components: {
    CarouselView,
    TopPrompt,
    HomeNav,
    // HolidayInspiration,
    FlyingUs
  },
  name: "Home",
  data() {
    return {};
  },
  props: {},
  watch: {},
  methods: {

  },
  filters: {},
  computed: {},
  created() {

  },
  mounted() {},
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
  .TopPrompt .ant-carousel >>> .slick-slide {
    text-align: center;
    height: 24px;
    line-height: 24px;
    background: transparent;
    overflow: hidden;
  }

  .TopPrompt .ant-carousel >>> .slick-slide p {
    color: rgba(51,51,51,1);
  }
</style>
